import { AbstractEvent as o } from "./ghl-ui.es345.js";
class t extends o {
  constructor(n) {
    super(n), this.data = n;
  }
  get source() {
    return this.data.source;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get mirror() {
    return this.data.mirror;
  }
  get sourceContainer() {
    return this.data.sourceContainer;
  }
  get sensorEvent() {
    return this.data.sensorEvent;
  }
  get originalEvent() {
    return this.sensorEvent ? this.sensorEvent.originalEvent : null;
  }
}
t.type = "drag";
class a extends t {
}
a.type = "drag:start";
a.cancelable = !0;
class i extends t {
}
i.type = "drag:move";
class r extends t {
  get overContainer() {
    return this.data.overContainer;
  }
  get over() {
    return this.data.over;
  }
}
r.type = "drag:over";
r.cancelable = !0;
function l(e) {
  return e.type === r.type;
}
class g extends t {
  get overContainer() {
    return this.data.overContainer;
  }
  get over() {
    return this.data.over;
  }
}
g.type = "drag:out";
class v extends t {
  get overContainer() {
    return this.data.overContainer;
  }
}
v.type = "drag:over:container";
class u extends t {
  get overContainer() {
    return this.data.overContainer;
  }
}
u.type = "drag:out:container";
class d extends t {
  get pressure() {
    return this.data.pressure;
  }
}
d.type = "drag:pressure";
class s extends t {
}
s.type = "drag:stop";
s.cancelable = !0;
class c extends t {
}
c.type = "drag:stopped";
export {
  t as DragEvent,
  i as DragMoveEvent,
  u as DragOutContainerEvent,
  g as DragOutEvent,
  v as DragOverContainerEvent,
  r as DragOverEvent,
  d as DragPressureEvent,
  a as DragStartEvent,
  s as DragStopEvent,
  c as DragStoppedEvent,
  l as isDragOverEvent
};
